import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  @Input() label: string = "Search";
  @Input() placeholder: string;
  @Input() appearance: string = "outline";
  @Input() searchValues: string[];
  @Input() isSmall: boolean = false;
  @Output() select = new EventEmitter<string>();

  searchText: string;
  myControl = new FormControl('');
  filteredOptions: Observable<string[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.searchValues.filter(option => option.toLowerCase().includes(filterValue));
  }

  selectItem(item: string) {
    this.select.emit(item);
  }
}